import { render, staticRenderFns } from "./QaList.vue?vue&type=template&id=6f49d3d1&scoped=true"
import script from "./QaList.vue?vue&type=script&lang=js"
export * from "./QaList.vue?vue&type=script&lang=js"
import style0 from "./QaList.vue?vue&type=style&index=0&id=6f49d3d1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f49d3d1",
  null
  
)

export default component.exports